import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import {t} from 'shared/core';
import _ from 'lodash';
import LiabilityCalculationModalContent from './LiabilityCalculationModalContent';

const LiabilityCalculationModal = observer(({isOpen, uiState}) => {
  const {employee, selectedLiabilityBalance} = uiState;

  return (
    <Modal
      title={t('employees.profile.time_off.liability.LIABILITY_CALCULATION_TITLE', { typeName: _.get(selectedLiabilityBalance, 'type.name') })}
      isOpen={isOpen}
      onHide={() => uiState.closeLiabilityCalculationModal()}
      size='md'
    >
      <LiabilityCalculationModalContent
        selectedLiabilityBalance={selectedLiabilityBalance}
        timeOffTypeId={_.get(selectedLiabilityBalance, 'type.id')}
        employee={employee}
      />
    </Modal>
  );
});

export default LiabilityCalculationModal;
